<template>
    <div class="col-md-12 mb-2">
         <b-card>
          <div slot="header">
            <b>Add/Edit Cargo Damage</b>
            <button type="button" aria-label="Close"  class="close" @click="$emit('prevPage')">Back</button>
          </div>
          <form >
          <div class="card-body1">
              <div class="form-group row">
                <div class="col-md-6">
                  <b-form-fieldset label="MPS Number :" description="">
                    <b-input-group left="<i class='fa fa-book'></i>">
                      <input class="form-control" id="awbnumber" v-model="ShipmentDetails.ShippingID" :disabled="disableFields" name="awbnumber" type="text"></b-form-input>  
                      <b-input-group-button slot="right" >
                        <b-button class="btn btn-secondary" :disabled="disableFields" @click="$emit('fetchDeails','ShipmentData.awbnumber')">Go <i
                            class="fa fa-arrow-right" aria-hidden="true"></i></b-button>
                      </b-input-group-button>
                    </b-input-group>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label> Current Region:</label>
                  <b-input-group left="<i class='fa fa-map-marker'></i>">
                    <b-form-input id="origin_hub_name" v-model="ShipmentDetails.Getallhubzone.ZoneName" :disabled="disableFields"  name="origin_hub_name">
                    </b-form-input>
                  </b-input-group>
                </div>
                <div class="col-sm-6">
                  <label>Origin Hub/SVC :</label>
                <b-input-group left="<i class='fa fa-map-marker'></i>">
                  <b-form-input id="current_hub_name" v-model="ShipmentDetails.Getallhubzone.originHubName" :disabled="disableFields" name="OriginHubName">
                  </b-form-input>
                </b-input-group>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label> Current Hub/SVC:</label>
                <b-input-group left="<i class='fa fa-map-marker'></i>">
                  <b-form-input id="current_hub_name" v-model="ShipmentDetails.Getallhubzone.currentHubName" :disabled="disableFields" name="current_region_name">
                  </b-form-input>
                </b-input-group>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12">
                  <b-form-fieldset name="DamageType" :disabled="disableFields" label="Damage Type:<span style='color: red'>*</span> " :label-cols="2" :horizontal="true">
                    <div>
                        <b-form-radio :disabled="disableFields" @change="selectData($event)" :options="[
                            {text: 'Minor',value: '1'},
                            {text: 'Major',value: '2'}
                          ]" :value="ShipmentDetails.damagetype"></b-form-radio>
                  </div>
                </b-form-fieldset>
               </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>Damage Zone :</label>
                    <b-input-group left="<i class='fa fa-university'></i>">
                  <b-form-input id="DamageZone" v-model="ShipmentDetails.Getallhubzone.DamageZoneName" :disabled="disableFields" name="DamageZone">
                  </b-form-input>
                </b-input-group>
                    <span v-show="errors.has('newhubs')" class="text-danger">{{ errors.first('newhubs') }}</span>
    
                  </div>
                  <div class="col-md-6">
                    <label>Damage Hub/SVC: :</label>
                    <b-input-group left="<i class='fa fa-university'></i>">
                     <b-form-input id="Damagehub" v-model="ShipmentDetails.Getallhubzone.DamageHubName" :disabled="disableFields" name="Damagehub">
                  </b-form-input>
                    </b-input-group>
                    <span v-show="errors.has('newhubs')" class="text-danger">{{ errors.first('newhubs') }}</span>
    
                  </div>
                </div>
                <div class="form-group row">
                   <div class="col-md-6">
                    <label>Damage Category: :</label>
                    <b-input-group left="<i class='fa fa-university'></i>">
                     <b-form-input id="DamageCategory" v-model="ShipmentDetails.Getallhubzone.damagecategoryName" :disabled="disableFields" name="DamageCategory">
                  </b-form-input>
                    </b-input-group>
                    <span v-show="errors.has('newhubs')" class="text-danger">{{ errors.first('newhubs') }}</span>
    
                  </div>
                     <div class="col-md-6">
                    <label>Reason:</label>
                    <b-input-group left="<i class='fa fa-university'></i>">
                     <b-form-input id="Reason" v-model="ShipmentDetails.Getallhubzone.ReasonName" :disabled="disableFields" name="Reason">
                  </b-form-input>
                    </b-input-group>
                    <span v-show="errors.has('newhubs')" class="text-danger">{{ errors.first('newhubs') }}</span>
    
                  </div>
                  </div>

                  <div class="form-group-row">
                    <label>Uploaded Pics:</label>
                    <div class = "imageGroup">
                      <div class="image-view-upload row" v-bind:key="index" v-for="(image, index) in images">
                        <img @click="showImage(image.url)" class="col-md-offset-1 col-md-2 col-sm-3 col-xs-4" :src="image.url"/>
                      </div>
                    </div>
                  </div>
                </div>

              <div class="form-group row">
                <div class="col-md-6">
                  <label>Description :</label>
                  <b-input-group>
                    <textarea  v-model="ShipmentDetails.loggeddescription" :disabled="disableFields" class="form-control" id="description" name="description"
                      rows="3"></textarea>
                  </b-input-group>
                </div>
                <div class="col-md-6">
                  <b-form-fieldset v-if="showOctroiMRP" label="Confirmed Claim Amount:" description="">
                    <b-input-group left="<i class='fa fa-inr'></i>">
                      <input class="form-control" id="OctroiMRP" v-model="ShipmentDetails.netvalue" :disabled="editOctroiMRP" name="OctroiMRP" type="text"></b-form-input>
                    </b-input-group>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="card-footer">
                <b-button  class="btn btn-sm btn-success"  @click="$emit('updateDetails',ShipmentDetails)" type="button"><i class="fa fa-check"></i> 
                <span v-if="ClikableBoxSave">Save</span>
              <span v-if="ClikableBoxConfirm">Confirm</span>
              <span v-if="ClikableBoxProcess">Process</span>
              <span v-if="ClikableBoxApprove">Approve</span>
              <span v-if="ClikableBoxVerified">Verify</span>
              <span v-if="ClikableBoxRecevied">Recevied</span>
             </b-button>

               <button v-if="ClikableBoxCanceltoall" class="btn btn-sm btn-danger" @click="$emit('prevPage')" type="Cancel"><i class="fa fa-times"></i>                
              <span>Cancel</span>
              </button>
               <b-button  v-if="ClikableBoxApprove" class="btn btn-sm btn-danger" @click="$emit('updateDetails',ShipmentDetails,isRejected)" type="Cancel"><i class="fa fa-times"></i>                
              <span>Reject</span>
               </b-button>
              </div>
            </form>
        </b-card>
      <b-modal id="imgPopUp" v-model="showModal" title="BootstrapVue">
        <b-card>
          <span class="download-btn"><i class="fa fa-download"></i> <a :href="img" download>Download</a> </span>
          <span @click="showModal = false">X</span>
          <img :src="img" alt="loading...">
        </b-card>
      </b-modal>
      </div>
</template>

<style scoped>
</style>

<style src="./actionComponent.component.scss" scoped lang="scss"></style>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "actionComponent",
  components: {
    Multiselect,
  },
  props: {
    ShipmentDetails: {
      type: Object,
      required: true,
    },
    fieldsAccessData: {
      type: Object,
      required: true,
    },
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      Damagezone: "",
      newhubs: "",
      Reason: "",
      val: 0,
      awbnumber: "",
      img: '',
      showModal: false,
      ClikableBoxSave:false,
      ClikableBoxConfirm:false,
      ClikableBoxApprove:false,
      ClikableBoxVerified:false,
      ClikableBoxRecevied:false,
      ClikableBoxApprove:false,
      ClikableBoxConfirm:false,
      ClikableBoxConfirm:false,
      ClikableBoxConfirm:false,
      ClikableBoxProcess:false,
      ClikableBoxCanceltoall:false,
      disableFields: false,
      showOctroiMRP: false,
      editOctroiMRP: true,
      isRejected:true,
      ShipmentData: {
        OctroiMRP: "",
      },
    };
  },
  watch: {
    fieldsAccessData: [
      {
        handler: "manageAccessInformation",
      },
    ],
  },
  methods: {
    manageAccessInformation(obj) {
      let accessObject = JSON.parse(JSON.stringify(obj));
      // if(accessObject.userBucket == 'Opration' || accessObject.status === 'Pending with Operations'){
      //   this.disableFields = true;
      // }
      if (accessObject.userBucket === "CLT") {
        this.showOctroiMRP = true;
        this.editOctroiMRP = false;
        this.ClikableBoxConfirm = true;
        this.disableFields = true;
        this.ClikableBoxCanceltoall = true;
      }
      if (accessObject.userBucket === "DEPS") {
        this.showOctroiMRP = true;
        this.editOctroiMRP = true;
        this.disableFields = true;
        this.ClikableBoxVerified = true;
        this.ClikableBoxCanceltoall = true;
      }
      if (
        accessObject.userBucket === "Finance" &&
        accessObject.status === "Pending with Finance (CN/COF)"
      ) {
        this.showOctroiMRP = true;
        this.editOctroiMRP = true;
        this.ClikableBoxConfirm = true;
        this.disableFields = true;
        this.ClikableBoxCanceltoall = true;
      }
      if (
        accessObject.userBucket === "Finance" &&
        accessObject.status === "Pending with Finance"
      ) {
        this.ClikableBoxApprove = true;
        this.disableFields = true;
      }
      if (accessObject.userBucket === "Opration" ) {
        this.ClikableBoxProcess = true;
        this.disableFields = true;
        this.ClikableBoxCanceltoall = true;
      }
      if (accessObject.userBucket === "DMG") {
        this.ClikableBoxRecevied = true;
        this.disableFields = true;
        this.ClikableBoxCanceltoall = true;
      }
    },
    reject(ShipmentDetails) {
      ShipmentDetails.isRejected = true;
      this.$emit("updateDetails", ShipmentDetails);
    },
    createDataObject() {
      console.log("Shipment Data :: ", this.ShipmentData.awbnumber);
      this.$emit();
    },
    showImage(filePath) {
      this.img = filePath;
      this.showModal = true;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/views/B2B components/actionComponent.vue?32458b65